<template>
  <div>
    <div class="fieldWrap">
      <ul class="fieldBx">
        <li class="formList">
          <dl>
            <dt class="formTit">회원 구분</dt>
            <dd class="d-flex align-center">
              <v-col class="mgr d-flex" sm="12">
                <span>
                <v-radio-group v-model="param.searchSecMember" row>
                  <v-radio
                      v-for="(s, idx) in userTypes"
                      :key="idx"
                      :label="s.text"
                      :value="s.value"
                  ></v-radio>
                </v-radio-group>
                </span>
                <span>
                  <v-checkbox class="mgr" label="" v-model="param.searchIsAntiGraftLawTarget" :true-value="true" :false-value="false">
                    <template v-slot:label>청탁금지대상 포함</template>
                  </v-checkbox>
                </span>
              </v-col>
<!--              <v-col class="d-flex" sm="3">-->
<!--                <v-select v-model="param.searchRole" :items="userRoleItems" item-text="roleName"-->
<!--                          item-value="roleId" label="역할"-->
<!--                          dense solo flat outlined clearable/>-->
<!--              </v-col>-->
<!--              <v-col class="d-flex" sm="3">-->
<!--                <v-select v-model="param.searchGroup" :items="departmentItems" item-value="groupId" item-text="groupName"-->
<!--                          dense-->
<!--                          flat-->
<!--                          solo-->
<!--                          clearable-->
<!--                          outlined-->
<!--                          label="분과"-->
<!--                          v-on:change="search"/>-->
<!--              </v-col>-->
<!--              <v-col class="d-flex" sm="3">-->
<!--                <v-select v-model="param.searchGroup" :items="clubItems" item-value="groupId" item-text="groupName"-->
<!--                          dense-->
<!--                          clearable-->
<!--                          flat-->
<!--                          solo-->
<!--                          outlined-->
<!--                          label="동호회"-->
<!--                          v-on:change="search"/>-->
<!--              </v-col>-->
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl>
            <dt class="formTit">포함할 회원</dt>
            <dd>
              <v-col class="mgr" sm="12">
                <user-search-component @callback-event="v => param.searchIncludeUsers = v"  />
              </v-col>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl>
            <dt class="formTit">제외할 회원</dt>
            <dd>
              <v-col class="mgr" sm="12">
                <user-search-component @callback-event="v => param.searchExcludeUsers = v"  />
              </v-col>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl class="wh100">
            <dt class="formTit">검색 키워드</dt>
            <dd class="checkSt">
              <v-col class="d-flex">
                <v-select :items="searchColumns" item-value="value" item-text="text" v-model="param.searchColumn"
                          dense
                          clearable
                          flat
                          outlined
                          hide-details
                          label="검색 컬럼"
                          style="padding-right: 10px; max-width: 200px;"
                />

                <v-text-field :label="searchColumnText"
                              v-model="param.searchKeyword" v-on:keyup.enter="search"
                              dense clearable flat outlined
                              style="padding-right: 10px; width:400px"
                />
                <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>
              </v-col>
            </dd>
          </dl>
        </li>
<!--        <li class="searchBtn">-->
<!--          <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>-->
<!--        </li>-->
      </ul>
    </div>
    <div class="d-flex">
      <div class="tableBx">
        <div class="tableBtnBx">
          <p class="searchAll">
            <v-checkbox class="mgr" label="" v-model="allSelected">
              <template v-slot:label>검색 된 총 <span class="txtPoint"> {{ totalItems }}명 </span> 선택</template>
            </v-checkbox>
          </p>
          <div class="tableBtn">
            <ul>
              <li class="tableBtnList" v-if="!allSelected"><span class="black-color">{{ selected != null ? selected.length : 0 }}</span> 건
                선택됨
              </li>
              <li class="tableBtnList">
                <v-btn color="primary" depressed dark @click="addTarget">
                  <v-icon small class="mr-2">mdi mdi-account-arrow-right</v-icon>
                  대상 추가</v-btn>
              </li>
            </ul>
          </div>
        </div>
        <div class="">
          <v-row dense class="pa-2 align-center">
            <v-col class="d-flex text-right">
              <v-spacer />
              <div class="text-right" style="color: red">"대상 추가" 후 "대상 저장"을 실행해야 최종 반영됩니다.</div>
            </v-col>
          </v-row>
          <v-data-table
              v-model="selected"
              :headers="headers"
              :items="users"
              :server-items-length="totalItems"
              :options.sync="options"
              :loading="listLoading"
              item-key="userId"
              :show-select="!allSelected"
              class="elevation-1"
              :footer-props="{showFirstLastPage: true, 'items-per-page-options' : [10,20,50,100,-1]}"
              disable-sort
          >
            <template v-slot:item.userHasRoles="{value}">
              <span
                  class="d-inline-block text-truncate"
                  style="max-width: 100px;"
              >
                {{ value.length > 0 ? value.length > 1 ? value[0].role.roleName + ' 외 ' + (value.length-1)  : value[0].role.roleName : '' }}
              </span>
            </template>
            <template v-slot:item.birthDate="{value, item}">
              {{ value }} {{ value != null ? item.lunarBirth ? '(음력)' : '(양력)' : '' }}
            </template>

          </v-data-table>
        </div>
      </div>

      <div class="tableBx">
        <div class="tableBtnBx">
          <p class="searchAll">
            <v-checkbox class="mgr" label="" v-model="targetAllSelected">
              <template v-slot:label>
                대상 전체 <span class="txtPoint"> {{ targetUsers.length }}명 </span> 선택
              </template>
            </v-checkbox>
          </p>
          <div class="tableBtn">
            <ul>
              <li class="tableBtnList" v-if="!targetAllSelected"><span class="black-color">{{ targetSelected != null ? targetSelected.length : 0 }}</span> 건
                선택됨
              </li>
              <li class="tableBtnList">
                <v-btn color="#58d8a3" depressed dark @click="sendSms">
                  <v-icon small class="mr-2">mdi mdi-cellphone-message</v-icon>
                  SMS 발송</v-btn>
              </li>
              <li class="tableBtnList">
                <v-btn color="orange" depressed dark @click="removeTarget">
                  <v-icon small class="mr-2">mdi mdi-account-minus</v-icon>
                  대상 제외</v-btn>
              </li>
              <li class="tableBtnList">
                <v-btn color="success" depressed dark @click="saveTarget">
                  <v-icon small class="mr-2">mdi mdi-content-save</v-icon>
                  선택 대상 저장</v-btn>
              </li>
              <li class="tableBtnList">
                <v-btn color="#607d8b" depressed dark @click="excelDownload">
                  <v-icon left dark class="mr-2">cloud_download</v-icon>
                  대상 회원 전체 다운로드
                </v-btn>
              </li>
            </ul>
          </div>
        </div>
        <div class="">
          <v-row dense class="pa-2 align-center">

            <v-col cols="6">
            </v-col>

            <v-col cols="6" class="d-flex text-right align-center">
              <v-text-field
                  v-model="searchQuery"
                  append-icon="mdi-magnify"
                  solo
                  rounded
                  hide-details
                  dense
                  clearable
                  placeholder="검색"
              ></v-text-field>
              <v-btn
                  :loading="targetListLoading"
                  icon
                  small
                  class="ml-2"
                  @click="memberReload()"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-col>

          </v-row>

          <v-data-table
              v-model="targetSelected"
              :headers="targetHeaders"
              :items="targetUsers"
              :loading="targetListLoading"
              item-key="userId"
              :show-select="!targetAllSelected"
              class="elevation-1"
              :footer-props="{showFirstLastPage: true, 'items-per-page-options' : [10,20,50,100,-1]}"
              :search="searchQuery"
          >
            <template v-slot:item.birthDate="{value, item}">
              {{ value }} {{ value != null ? item.lunarBirth ? '(음력)' : '(양력)' : '' }}
            </template>
          </v-data-table>
        </div>
      </div>

    </div>

    <v-dialog v-model="smsDialogVisible" max-width="350px" @click:outside="smsDialogVisible = false" @keydown.esc="smsDialogVisible = false">
      <v-card class="mx-auto">
        <v-system-bar>
          SMS 발송
          <v-spacer></v-spacer>
          <v-icon @click="smsDialogVisible = false">mdi-close</v-icon>
        </v-system-bar>
        <v-card-text>

          <mobile-component
              :param="param"
              :selected="targetSelected"
              :default-message="smsMessage"
              :default-title="smsTitle"
              @callback-event = "v => smsDialogVisible = !v"
              :group-id="id"
              from="present"
          />

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import userApi from '@/api/UserApi'
import secUserApi from '@/api/SecUserApi'
import roleApi from '@/api/RoleApi'
import groupApi from "@/api/GroupApi";

import userSearchComponent from "@/views/component/UserSearchComponent";
import mobileComponent from "@/views/component/MobileComponent";

import _ from 'lodash';
import presentApi from "@/api/PresentApi";
import orderApi from "@/api/OrderApi";

export default {
  name: "Member",
  props:['id'],
  components: {
    userSearchComponent,
    mobileComponent
  },
  data: () => ({
    searchColumns: [
      {value: null, text: '전체'},
      {value: 'name', text: '이름'},
      {value: 'retirementDepartment', text: '부서'},
      {value: 'retirementPosition', text: '직위'},
      {value: 'mobileNo', text: '휴대폰번호'},
      {value: 'userId', text: '아이디'},
      {value: 'email', text: '이메일'}
    ],
    userTypes: [{value: null, text: '전체'}, {value: true, text: '삼성전자 관리 회원'}, {value: false, text: '전자사랑 회원'}],
    smsMessage:null,
    smsTitle:null,
    smsDialogVisible: false,
    user: {},
    userType: [{text: '전체', value: null}, {text: '1 회원', value: false}, {text: '2 회원', value: true}],
    userStateItems: [],
    userRoleItems: [],
    departmentItems:[],
    clubItems:[],
    present: {
      includeUserList: [],
      exceptUserList: []
    },
    templateParam: {
      title: null,
      system: false
    },
    templateData: {
      templateId: null
    },
    includeMobileList: [],
    includeUser: '',
    includeMobileNo: '',
    exceptUser: '',
    includeMobileNos: [],
    users:[],
    targetUsers:[],
    listLoading: true,
    targetListLoading: false,
    allSelected: false,
    targetAllSelected: false,
    options: {
      page: 1,
      itemsPerPage: 10
    },
    templatePageOptions: {
      page: 1,
      itemsPerPage: 4,
      length: 0,
      visible: 10
    },
    templateList: [],
    templateTotalItems: 0,
    totalItems: 0,
    singleSelect: false,
    param:{
      searchSecMember: true
    },
    selected: [],
    targetSelected: [],
    headers: [
      // {text: '역할', value: 'userHasRoles', align: 'left'},
      {text: '이름', value: 'name', align: 'left'},
      {text: '직위', value: 'retirementPosition', align: 'left'},
      {text: '부서', value: 'retirementDepartment', align: 'left'},
      {text: '생년월일', value: 'birthDate'},
      // {text: '아이디', value: 'userId', align: 'left'},
      // {text: '분과', value: 'retirement_department', align: 'left'},
      // {text: '동호회', value: 'clubGroup', align: 'left'},
      {text: '휴대폰번호', value: 'mobileNo'}
      // {text: '이메일', value: 'email', align: 'left'}
    ],
    targetHeaders: [
      {text: '이름', value: 'name', align: 'left'},
      {text: '직위', value: 'retirementPosition', align: 'left'},
      {text: '부서', value: 'retirementDepartment', align: 'left'},
      {text: '생년월일', value: 'birthDate'},
      {text: '휴대폰번호', value: 'mobileNo'}
    ],
    hourList: [],
    minuteList: [],
    searchUserKeyword:null,
    attachFileServerUrl: process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    waitingSearch: false,
    searchQuery: null,
  }),
  computed: {
    searchColumnText() {
      if(this.param.searchColumn) {
        return (this.searchColumns.filter(c => c.value === this.param.searchColumn)?.[0]??{}).text;
      } else {
        return '이름/직위/부서/휴대폰번호/아이디/이메일 검색'
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.search()
      },
      deep: true,
    },
    targetAllSelected(v) {
      if(v) {
        this.targetSelected = this.targetUsers
      } else {
        this.targetSelected = []
      }
    },
    allSelected(v) {
      if(v) {
        this.selected = this.users
      } else {
        this.selected = []
      }
    }
  },
  methods: {
    async excelDownload() {
        const passwd = prompt('엑셀에 설정할 패스워드를 입력하세요.(선택사항)', '');
        const params = {};
        let prefix = this.present.title;
        const suffix = "";
        params.excelPassword = passwd;
        await orderApi.usersExcel(this.id, params, prefix, suffix);
    },
    memberReload() {
      this.searchQuery = null
      this.getUsers();
    },
    sendSms() {
      this.smsDialogVisible=true
      this.smsMessage = `안녕하세요. {NAME}님,\n\n아래 선물 선택하기 링크를 클릭하세요.\n\n▶ 선물 선택하기\n${process.env.VUE_APP_SMS_URI}/gift/${this.id}`
      this.smsTitle = `${this.present.title}`
    },
    addTarget() {
      if(this.allSelected) {
        this.targetListLoading = true;
        const params = this.getParam();
        secUserApi.list(params).then(data => {
          // this.selected = [...this.selected, ...this.users]
          this.targetUsers = _.uniqBy([..._.cloneDeep(this.selected), ...data], "mobileNo")
          this.targetListLoading = false;
        });
      } else {
        this.targetUsers = _.uniqBy([..._.cloneDeep(this.selected),...this.targetUsers], "mobileNo")
      }
      // console.log(this.targetUsers)
    },
    removeTarget() {
      if(this.targetAllSelected) {
        this.targetUsers = []
      } else {
        this.targetUsers = this.targetUsers.filter(t => this.targetSelected.map(s => s.userId).indexOf(t.userId) === -1);
      }
      this.targetSelected = [];
    },
    saveTarget() {
      if(!this.targetSelected || this.targetSelected.length === 0) {
        if(!confirm("선택된 대상이 없습니다.\n모두 삭제하시겠습니까?")) {
          return
        }
      }

      if(!this.targetAllSelected) {
        if(!confirm("미선택 대상은 삭제됩니다.\n선택된 대상을 저장하시겠습니까?")) {
          return
        }
      }

      orderApi.saveUsers(this.id, this.targetSelected.map(user => user.userId)).then(() => {
        alert('저장되었습니다.')
        this.getUsers()
      });
    },
    userGroupName(value) {
      const approvalList = value?.filter(v => v.joinState === 'STATE_APPROVAL')??[];
      const approvalSize = approvalList.length;
      const masterGroup = approvalList?.[0]?.groupName??'';

      return masterGroup + (approvalSize > 1 ? ' 외 ' + (approvalSize-1) : '')
    },
    search() {
      this.listLoading = true;

      const params = this.getParam();
      secUserApi.pagedList(params).then(data => {
        this.users = data.content;
        // this.selected = [...this.selected, ...this.users]
        this.totalItems = data.totalElements;
        this.listLoading = false;
        this.selected = [];
        if(this.allSelected)
          this.selected = this.users;
      });

    },
    addMobileNo(value) {
      this.includeMobileList = value.map(v => v.text);
    },
    getParam() {
      const {  page, itemsPerPage, size } = this.options;
      const params = {...this.param, ...this.options, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};
      if (this.activeItem > 0) {
        // params.fromJoin = this.fromDate;
        // params.toJoin = this.toDate;
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      // params.ids = this.ids;
      params.searchIncludeUsers = this.param.searchIncludeUsers?.map(o => o.userId)??null;
      params.searchExcludeUsers = this.param.searchExcludeUsers?.map(o => o.userId)??null;

      params.searchState = "STATE_NORMAL";
      if(params.searchIsAntiGraftLawTarget)
        params.searchIsAntiGraftLawTarget = null;
      else
        params.searchIsAntiGraftLawTarget = false;
      return params;
    },
    getUsers() {
      orderApi.getUsers(this.id).then(data => {
        this.targetUsers = data;
      })
    }

  },
  created: function () {
    // this.search();
    this.getUsers();
    userApi.stateList().then(data => {
      // console.log(data);
      this.userStateItems = data;
    });
    roleApi.list(true).then(data => {
      this.userRoleItems = data;
    });
    groupApi.flatList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatList(2).then(data => {
      this.clubItems = data;
    });

    presentApi.get(this.id).then(data => {
      this.present = data;
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/style/layout/variables';

.col {
  padding: 0;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
          flex: 0 0 80px;
        }

        dd {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.tableBtnBx {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .searchAll {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    /*font-size: 13px;*/
    .txtPoint {
      color: $point-color;
    }
  }
}

.tableBx {
  flex: 1 auto;
  margin-right: 30px;

  ul {
    display: flex;
    flex-direction: row;
    align-items: center;

    .tableBtnList {
      margin-right: 15px;
    }
  }
}

.ti-new-tag-input {
  font-size: 12px;
}

</style>
